"use strict";
/*
    Package Name: simple-browser-fingerprint
  Author: Seyyedmahdi hassanpour
  email:seyyedkhandon@gmail.com
*/
Object.defineProperty(exports, "__esModule", { value: true });
var simpleBrowserFingerprint = function (return_as_array) {
    if (return_as_array === void 0) { return_as_array = false; }
    try {
        var browser_features = [];
        var browser = navigator;
        for (var key in browser) {
            var value = browser[key];
            if (typeof value === 'object')
                value = JSON.stringify(value);
            browser_features.push(key + ":" + value);
        }
        return return_as_array ? browser_features : browser_features.join(',');
    }
    catch (e) {
        return '';
    }
};
exports.default = simpleBrowserFingerprint;
